export default __webpack_public_path__ + "static/media/Imagen3.67ccdd3c.jpg";